import Vue from 'vue';

/**
 * Simple action pre-processor that allows
 * actions to register async steps to occur before
 * being able to generate a payload.
 */
export class ActionPreProcessor {
    constructor() {
        this.bus = new Vue();
        this.processes = [];
        this.register();
    }

    /**
     * Register base events on the bus
     */
    register() {
        this.bus.$on('push-action', v => this.pushAction(v));
    }

    /**
     * Add an action delegate to the process list
     * @param delegate
     */
    pushAction(delegate) {
        this.processes.push(delegate);
    }

    /**
     * Resolve all processes present after requesting
     * them from the actions in the form.
     * @returns {Promise<void>}
     */
    async resolve() {
        this.processes = [];
        this.bus.$emit('resolve');
        if (this.processes.length) {
            await Promise.all(this.processes.map(v => v()));
        }
    }
}

export default new ActionPreProcessor();
